import { PaymentProcessorConfigurationBase } from '../payment-processor-configuration-base';

export class KanPayPaymentProcessorConfiguration extends PaymentProcessorConfigurationBase {
  soapurl: string;

  constructor(options?: Partial<KanPayPaymentProcessorConfiguration>) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }
  }
}
